import React from "react";
import { Link } from "react-router-dom";
import { Button, Icon } from "@weezevent/nacre";
import { ADAPTIVE_STATES } from "../../constants/ADAPTIVE_STATES";
import PropTypes from "prop-types";
import useAdaptiveState from "../../utils/useAdaptiveState";
import Style from "./adaptive-header-button.module.scss";

const AdaptiveHeaderButton = ({ icon, label, to }) => {
	const size = useAdaptiveState();

	return (
		<Button as={Link} to={to} primary>
			<span className={Style["button"]}>
				{size > ADAPTIVE_STATES.MOBILE ? label : null}
				{icon && <Icon name={icon} />}
			</span>
		</Button>
	);
};

AdaptiveHeaderButton.propTypes = {
	icon: PropTypes.string,
	label: PropTypes.string.isRequired,
	to: PropTypes.string.isRequired
};

AdaptiveHeaderButton.defaultProps = {
	icon: null
};

export default AdaptiveHeaderButton;
